ParametersCategoryEditionController.$inject = ['$scope', 'ParametersFactory', 'tmhDynamicLocale', '$translate', '$stateParams', '$uibModalInstance', 'category', 'actionType'];
export function ParametersCategoryEditionController($scope, ParametersFactory, tmhDynamicLocale, $translate, $stateParams, $uibModalInstance, category, actionType) {
  init();
  $scope.saveCategory = saveCategory;
  $scope.cancel = cancel;

  function saveCategory() {
    $uibModalInstance.close($scope.myCategory);
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function init() {
    $scope.isAddition = (actionType == 'addition') ? true : false;
    $scope.isEdition = (actionType == 'edition') ? true : false;
    if (category) {
      $scope.myCategory = {
        'nameFr': category.name_fr,
        'nameEn': category.name_en,
        'nameEs': category.name_es,
        'nameNl': category.name_nl
      };
    } else {
      $scope.myCategory = {
        'nameFr': '',
        'nameEn': '',
        'nameEs': '',
        'nameNl': ''
      };
    }

  }

}
